import { useEffect, useRef } from 'react';

/**
 * Returns a mutable ref whose current value is kept in sync with the latest value.
 * Useful when callbacks need stable references to evolving data without re-renders.
 */
export const useLatestRef = <T>(value: T) => {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
};

